import { render, staticRenderFns } from "./FormatListBulletedIcon.vue?vue&type=template&id=6f090b52"
import script from "./FormatListBulletedIcon.vue?vue&type=script&lang=js"
export * from "./FormatListBulletedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports